import { render } from "./LitigationForm.vue?vue&type=template&id=003f75e5&ts=true"
import script from "./LitigationForm.vue?vue&type=script&lang=ts"
export * from "./LitigationForm.vue?vue&type=script&lang=ts"

import "./LitigationForm.vue?vue&type=style&index=0&id=003f75e5&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__